<div class="container" *ngIf="showData">
  <div class="row">
    <div class="col s12 m6 l6 xl6 erro_seds error_div">
      <div class="squircle_msg">
        <div class="title">Oops!</div>
        <div class="msg">Falha ao acessar o SerasaJud</div>
      </div>
    </div>

    <div class="col s12 m6 erro_seds msg_div">
      <h6 class="darkblue-text">
        <span [innerHTML]="mensagemHtml"></span>
        <br /><br />
  
      </h6>

      <br />

      <div class="button-group">
        <button
          mat-raised-button
          type="button"
          (click)="loginAgain()"
          class="btn btn-azul btn-block"
          [attr.data-cy]="'button-voltar'"
        >
          <mat-icon>arrow_back</mat-icon>
          Voltar
        </button>
      </div>
    </div>
  </div>
</div>